@if (showBooleanRadio) {
    <div class="agpr-formField agpr-booleanRadio">
        <agpr-radio
            [label]="field.labelTrue"
            [hiddenLabel]="field.labelTrue"
            [(ngModel)]="value"
            [value]="true"
            (ngModelChange)="onRadioChanged()"
        ></agpr-radio>
        <agpr-radio
            [label]="field.labelFalse"
            [hiddenLabel]="field.labelFalse"
            [(ngModel)]="value"
            [value]="false"
            (ngModelChange)="onRadioChanged()"
        ></agpr-radio>
    </div>
}
